import { consolidateMmyOrVin } from './helpers';
import {productsWithLicenses, directMonthly, directAnnual, upfrontPayments, transactionLimit, annualTermLength} from '../../../settings';

export default {
    isSoftwareCartEmpty: (state) => state.isSoftwareCartEmpty,
    isHardwareCartEmpty: (state) => state.isHardwareCartEmpty,
    hasMultilineShipping: (state) => state.hasMultilineShipping,
    cablesInCartCount: (state) => state.cablesInCartCount,
    productsInCart: (state) => state.productsInCart,
    productCostsInfo: (state) => state.productCostsInfo,
    hardwareCart: (state) => state.hardwareCart,
    softwareCart: (state) => state.softwareCart,
    softwareMap: (state) => state.softwareMap,
    consolidatedMmyData: function(state, getters, rootState) {
        return consolidateMmyOrVin(state.productsInCart, rootState, 'MMY');
    },
    consolidatedVinData: function(state, getters, rootState) {
        return consolidateMmyOrVin(state.productsInCart, rootState, 'Vin');
    },
    consolidatedManualSelectionData: function(state, getters, rootState) {
        let consolidatedData = {};
        for (let product of state.productsInCart) {
            let cableSelectionModule = `${product.productKey}${product.offerKey}CableSelection`;
            if (Object.keys(rootState).includes(cableSelectionModule)) {
                let manualSelectionData = rootState[cableSelectionModule].manualSelection.manualSelectionData;
                for (let [cableSku, quantity] of Object.entries(manualSelectionData)) {
                    if (cableSku in consolidatedData) {
                        consolidatedData[cableSku] += quantity;
                    } else {
                        consolidatedData[cableSku] = quantity;
                    }
                }
            }
        }
        return consolidatedData;
    },
    couldProductInCartHaveLicenses: function(state) {
        for (let product of state.productsInCart) {
            if (product.offerKey === "Hardware" && productsWithLicenses.includes(product.productKey)){
                return true;
            }
        }
        return false;
    },
    transactionTotal: function(state, getters, rootState) {
        if (rootState.checkout.selectedPaymentType === directMonthly) {
            return state.productCostsInfo.totals.software.monthly * annualTermLength;
        } else if (rootState.checkout.selectedPaymentType === directAnnual) {
            return state.productCostsInfo.totals.software.annual;
        }
        return state.productCostsInfo.totals.software.upfront;
    },
    transactionLimitExceeded: function(state, getters, rootState) {
        if (rootState.checkout.isSelfServiced && rootState.checkout.selectedPaymentType != upfrontPayments) {
            if (getters.transactionTotal > transactionLimit) {
                return true;
            }
        }
        
        return false;
    },
    renewalDiscountMatrix: (state) => state.renewalDiscountMatrix
}

